module.exports = __webpack_public_path__ + "img/image-capture.3f409227.svg";